import dayjs from "dayjs";
import i18next from "i18next";

const INTL_LOCALE: Record<string, string> = { hy: "hy-AM", ru: "ru-RU", en: "en-GB" };

/** Thousands separators per UI language (hy-AM: 12 345). */
export function formatNumber(n: number | null | undefined): string {
  if (n === null || n === undefined) return "";
  return new Intl.NumberFormat(INTL_LOCALE[i18next.language] ?? "hy-AM").format(n);
}

/** dd.mm.yyyy, the format auditors use in correspondence. */
export function formatDate(iso: string | null | undefined): string {
  if (!iso) return "";
  const d = dayjs(iso);
  return d.isValid() ? d.format("DD.MM.YYYY") : iso;
}

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return "";
  const d = dayjs(iso);
  return d.isValid() ? d.format("DD.MM.YYYY HH:mm") : iso;
}

export function formatBytes(n: number | null | undefined): string {
  if (!n && n !== 0) return "";
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`;
  return `${(n / 1024 / 1024).toFixed(1)} MB`;
}
